<template>
    <main-content>
        <kt-panel class="no-mb">
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills nav-sm-size" role="tablist">
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#users-reports" @click="gotoTab(1)">
                                {{ $t('reports.users.users-reports') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#officialFactor" @click="gotoTab(2)">
                                {{ $t('reports.users.official-factor') }}
                            </a>
                        </li>
<!--                        <li class="nav-item">-->
<!--                            <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#topuserchart" @click="gotoTab(3)">-->
<!--                                {{ $t('reports.users.top_users_chart') }}-->
<!--                            </a>-->
<!--                        </li>-->

                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 4 ? 'active' : '']" href="#unofficialFactor" @click="gotoTab(4)">
                                {{ $t('reports.users.unofficial-factor') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
        </kt-panel>
        <kt-panel-body>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" v-if="currentTab === 1">
                    <user-filter :action="filterAction" :exportExcel="exportToExcel"></user-filter>
                    <div >
            <kt-row v-if="$can('read-sensitive-info', 'user')">
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <accounting-statistics
                            :accountingStatistics="statistics.total_transactions"
                            :title="$t('reports.gateways.total_transactions')"
                    />
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <accounting-statistics
                            :accountingStatistics="statistics.total_wage"
                            :title="$t('reports.gateways.total_wage')"
                    />
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <accounting-statistics
                            :accountingStatistics="statistics.unsettled_balance"
                            :title="$t('reports.gateways.unsettled_balance')"
                    />
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <accounting-statistics
                            :accountingStatistics="statistics.settled_balance"
                            :title="$t('reports.gateways.settled_balance')"
                    />
                </div>
            </kt-row>
        </div>
                    <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
                </div>
                <div :class="['tab-pane', currentTab === 2 ? 'active' : '']" v-if="currentTab === 2">
                    <official-factor></official-factor>
                </div>
<!--                <div :class="['tab-pane', currentTab === 3 ? 'active' : '']" v-if="currentTab === 3">-->
<!--                    <topuserchart></topuserchart>-->
<!--                </div>-->
                <div :class="['tab-pane', currentTab === 4 ? 'active' : '']" v-if="currentTab === 4">
                    <unofficial-factor-filter></unofficial-factor-filter>
                </div>
            </div>
        </kt-panel-body>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content';
import userFilter from "./components/userFilter";
import columns from "./datatable/usersColumns";
import { ApiUrl } from '@/common/api.service';
import  statistics  from './components/accounting-statistics';
import  officialFactor  from './components/official-factor';
// import topUserChart from './components/top-users-chart.vue'
import { AuthorizationHeader } from '@/common/jwt.service';
import axios from "axios";
import {mapGetters} from "vuex";
import { i18n } from '@/plugins/i18n'
import toastr from "toastr";
import { KTApp } from '@/plugins/core/app'
import $ from "jquery";
import UnofficialFactorFilter from "@/views/reports/components/unofficial-factor-filter.vue";

export default {
    components: {
        UnofficialFactorFilter,
        'main-content': mainContent,
        'user-filter': userFilter,
        'accounting-statistics': statistics,
        'official-factor': officialFactor,
        // 'topuserchart': topUserChart
    },
    data() {
        return {
            currentTab: 1,
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "gateways_report_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('reports/admin/users'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                // actions: actionsColumn
            }
        },
        ...mapGetters('reports', [
            'statistics','status'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },

    methods: {
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
            window.localStorage.setItem('users_reports_active_tab', selectedTab);
            if(this.currentTab === 1 ){
                this.$store.dispatch('reports/fetchUsersStatistics')
            }
        },
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$store.dispatch('reports/fetchUsersStatistics', query)
                this.$refs.datatable.reload()
            }
        },
        exportToExcel(e, query){
            this.query = query

            let btn = $('#export_btn')
            KTApp.progress(btn)

            axios({
                url: ApiUrl.path('reports/admin/users-excel-export'),
                method: 'GET',
                params: this.query,
                responseType: 'blob',
            }).then(
                response => {
                    KTApp.unprogress(btn)

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'users_reports.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                },
                error => {
                    this.toastr.error(i18n.t('reports.tax.failedMessage'))
                });

        }
    },
    mounted() {
        if (window.localStorage.getItem('secondPreviousRoutePath') === this.$router.history.current.path) {
            let tab = window.localStorage.getItem('users_reports_active_tab');
            this.currentTab = (tab != null && tab != undefined) ? parseInt(tab) : 1;
        }
        this.$store.dispatch('reports/fetchUsersStatistics')
    }
}
</script>

<style scoped>
@media screen and (max-width:678px) {
    ul{
        width: 100%;
        text-align: center;
        margin: auto;
        display: flex !important;
        align-items: center;
        justify-content: center;
    }
}
</style>